import { Button, Grid, Heading, Text } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../redux/hooks'
import { getIsMobile } from '../../redux/reducers/appSettings'
import { RenderIf } from '../chemistry/higherOrderComponents/renderIf'
import { PageTemplate } from '../chemistry/skeleton'
import { ButtonWrapper } from '../details/Fields/GoToPayment/styles'
import BookingInformationPage from './bookingInformation'
import PackageInformationPage from './packageInformation'
import PaymentMethodsPage from './paymentMethods'
import PaymentOverviewPage from './paymentoverview'
import { PropsCheckoutTemplate } from './props'
import { StyledCheckout } from './styles'

const CheckoutTemplate = ({
    antiSpam,
    canBook,
    children,
    isBooking,
    isPackage,
    onClickBook,
    paymentInfo,
    shouldShowPaymentMethods,
    hasFinalizeErrored,
}: PropsCheckoutTemplate): ReactElement => {
    const { t } = useTranslation()

    const isMobile = useAppSelector((state) => getIsMobile(state))

    const ctaButton = (
        <Grid gap={32}>
            <PaymentOverviewPage />
            <ButtonWrapper>
                <Grid gap={16}>
                    {shouldShowPaymentMethods && <PaymentMethodsPage />}
                    <Button
                        data-cy="checkoutCTA"
                        disabled={!canBook && !antiSpam}
                        onClick={onClickBook}
                        size="large"
                        variant="success"
                    >
                        {isPackage
                            ? t('checkout.ctabtn.package')
                            : t('common:book')}
                    </Button>
                </Grid>
            </ButtonWrapper>
        </Grid>
    )

    const top = (
        <Heading bold primary size={isMobile ? 5 : 4}>
            {t('checkout.title')}
        </Heading>
    )

    const body = (
        <>
            <RenderIf condition={!hasFinalizeErrored}>
                <StyledCheckout>
                    {paymentInfo && (
                        <Grid
                            gap={isMobile ? 16 : 32}
                            autoFlow={isMobile ? 'row' : 'column'}
                        >
                            {isMobile && top}
                            <Grid
                                autoFlow={isMobile ? 'row' : 'column'}
                                css={{
                                    gap: isMobile ? 16 : 64,
                                    gridTemplateColumns: isMobile
                                        ? '1fr'
                                        : '1fr 1fr',
                                }}
                            >
                                {isBooking && <BookingInformationPage />}
                                {isPackage && <PackageInformationPage />}
                                {ctaButton}
                            </Grid>
                        </Grid>
                    )}
                    {children}
                </StyledCheckout>
            </RenderIf>
            <RenderIf condition={hasFinalizeErrored}>
                <Text>{t('checkout.finalize.error.text')}</Text>
            </RenderIf>
        </>
    )

    return (
        <PageTemplate
            Top={!isMobile && top}
            Body={body}
            Modal={undefined}
            bodyOverlap={!isMobile}
        />
    )
}

export default CheckoutTemplate
